import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { BackgroundJob } from '../services/background-job/background-job.service';
import { FormValidatorsService } from '../services/form-validators/form-validators.service';
import { SnackBarService } from '../services/snackbar/snackbar.service';
import { MaterialModule } from './../modules/material.module';
import { ActivitiesModalComponent } from './activities/activities-modal.component';
import { ActivitiesModalModule } from './activities/activities-modal.module';
import { ActivityStatusModalComponent } from './activities/activity-status-modal/activity-status-modal.component';
import { ActivityStatusModalModule } from './activities/activity-status-modal/activity-status-modal.module';
import { AddCareerModalModule } from './add-career/add-career.module';
import { AlertModalcomponent } from './alert/alert-modal.component';
import { AssignSupportModalService } from './assign-support/assign-support-modal.service';
import { AssignSupportModalModule } from './assign-support/assign-support.modal.module';
import { BatchEditModule } from './batch-edit/batch-edit-modal.module';
import { ConfirmModalComponent } from './confirm/confirm-modal.component';
import { CsvUploadConfirmModalComponent } from './csv-upload/confirm-modal/csv-upload-confirm-modal.component';
import { CsvUploadErrorModalComponent } from './csv-upload/error-modal/csv-upload-error-modal.component';
import { CsvUploadFixErrorsModalComponent } from './csv-upload/fix-errors-modal/csv-upload-fix-errors-modal.component';
import { ErrorModalComponent } from './error/error-modal.component';
import { FlagIgnoreModalComponent } from './flag-ignore/flag-ignore-modal.component';
import { FlagLogActionModalComponent } from './flag-log-action/flag-log-action-modal.component';
import { HistoryAllHelperService } from './history-all/history-all-helpers.service';
import { HistoryAllModalComponent } from './history-all/history-all-modal.component';
import { ListSummaryModalModule } from './list-summary/list-summary-modal.module';
import { EOPMilestoneModalModule } from './milestone/eop-milestone-modal/eop-milestone-modal.module';
import { FinalDecisionMilestoneModalModule } from './milestone/final-decision-milestone-modal/final-decision-milestone-modal.module';
import { ModalsService } from './modals.service';
import { SyncedSheetColumnsModalComponent } from './other-tools/synced-sheet-columns/synced-sheet-columns-modal.component';
import { SyncedSheetColumnsModule } from './other-tools/synced-sheet-columns/synced-sheet-columns-modal.module';
import { SyncedSheetModalComponent } from './other-tools/synced-sheet/synced-sheet-modal.component';
import { SyncedSheetModule } from './other-tools/synced-sheet/synced-sheet-modal.module';
import { StudentActivitiesModalModule } from './student-activities/student-activities-modal.module';
import { StudentPathsModule } from './student-paths/student-paths-modal.module';
import { StudentReportModalModule } from './student-report/student-report.module';
import { UserManagementModalModule } from './user-management/user-management-modal.module';
import { ShelterClusterUserManagementModalModule } from './shelter-user-management/shelter-user-management-modal.module';

@NgModule({
  declarations: [
    FlagLogActionModalComponent,
    FlagIgnoreModalComponent,
    HistoryAllModalComponent,
    AlertModalcomponent,
    ErrorModalComponent,
    ConfirmModalComponent,
    CsvUploadErrorModalComponent,
    CsvUploadConfirmModalComponent,
    CsvUploadFixErrorsModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MaterialModule,
    MatMenuModule,
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSnackBarModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BatchEditModule,
    StudentPathsModule,
    StudentReportModalModule,
    AssignSupportModalModule,
    StudentActivitiesModalModule,
    ActivitiesModalModule,
    SyncedSheetModule,
    SyncedSheetColumnsModule,
    ActivityStatusModalModule,
    AddCareerModalModule,
    EOPMilestoneModalModule,
    FinalDecisionMilestoneModalModule,
    ListSummaryModalModule,
    NvDesignLibraryModule,
    UserManagementModalModule,
    ShelterClusterUserManagementModalModule,
  ],
  exports: [
    FlagLogActionModalComponent,
    FlagIgnoreModalComponent,
    HistoryAllModalComponent,
    AlertModalcomponent,
    ErrorModalComponent,
    ConfirmModalComponent,
    CsvUploadErrorModalComponent,
    CsvUploadConfirmModalComponent,
    CsvUploadFixErrorsModalComponent,
  ],
  providers: [
    ModalsService,
    FormValidatorsService,
    HistoryAllHelperService,
    AssignSupportModalService,
    BackgroundJob,
    SnackBarService,
  ],
  entryComponents: [
    // mat dialog components must be added as an `entryComponent`. More info in the link below: (CM)
    // https://material.angular.io/components/dialog/overview#configuring-dialog-content-via-code-entrycomponents-code-
    FlagLogActionModalComponent,
    FlagIgnoreModalComponent,
    HistoryAllModalComponent,
    AlertModalcomponent,
    ErrorModalComponent,
    ConfirmModalComponent,
    ActivitiesModalComponent,
    ActivityStatusModalComponent,
    CsvUploadErrorModalComponent,
    CsvUploadConfirmModalComponent,
    SyncedSheetModalComponent,
    SyncedSheetColumnsModalComponent,
    CsvUploadFixErrorsModalComponent,
  ],
})
export class ModalsModule {}
